export default function People(props: any) {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_1459_6204)">
                <path
                    d="M11.2129 19.6961C11.2129 19.6961 11.9508 16.9487 12.6914 16.6652C13.595 16.3216 15.7622 15.5554 15.7622 15.5554C15.9337 15.4987 16.0657 13.9662 16.0657 13.9662C15.6285 13.547 14.9152 12.8529 14.7438 11.9183C13.775 11.7465 13.1749 10.0284 14.0579 9.9769C13.4356 7.91525 14.6975 5.91201 16.0468 5.74193C15.8376 5.05471 15.9165 4.16992 17.295 4.16992C18.6306 4.16992 18.6306 5.25572 18.4369 5.71616C20.028 5.70413 21.1339 7.96335 20.4035 9.96831C21.2745 9.90302 20.8338 11.5248 20.0074 11.8307C19.8925 12.8615 19.0044 13.6913 18.4352 13.9576C18.4352 13.9576 18.5586 15.4884 18.7386 15.5468C18.7386 15.5468 21.2127 16.191 22.0529 16.6566C22.9564 17.1583 23.4999 18.4589 23.4999 18.4589"
                    stroke="#010101"
                    strokeWidth="1.21008"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.6997 16.3027C13.0712 16.0066 10.4735 15.3145 10.4735 15.3145C10.1436 15.261 10.1523 14.1211 10.1575 13.7197C11.1681 13.1489 11.6352 11.6434 11.5865 11.0993C12.4061 10.7425 12.9461 9.09251 11.8036 9.21203C12.6318 8.55915 12.6544 3.98008 9.59663 3.57515C6.63088 3.1845 7.10144 4.44209 6.75416 4.48133C5.17752 4.67934 4.21729 6.6023 5.39804 9.20846C4.18256 8.88559 4.90317 10.953 5.52653 11.2545C5.48312 12.1143 6.38257 13.2167 6.99725 13.7162C6.98163 14.1211 7.03372 15.1593 6.68297 15.3109C6.68297 15.3109 3.98462 15.9656 3.26749 16.4365C2.83512 16.7219 2.5 18.3648 2.5 18.3648C7.39988 20.6063 17.1996 20.3553 23.4995 18.4677"
                    stroke="#010101"
                    strokeWidth="1.21008"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1459_6204">
                    <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
